import script from "./DateInput.vue?vue&type=script&setup=true&lang=js"
export * from "./DateInput.vue?vue&type=script&setup=true&lang=js"

import "./DateInput.vue?vue&type=style&index=0&id=5761a1b9&lang=css"

const __exports__ = script;

export default __exports__